import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import BtnLoader from 'Components/Common/Loader/BtnLoader';
import axios from 'axios';
import { loadDecrypted } from "Common Usage/localStorageUtils"; // <-- added

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 500,
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: 8,
    boxShadow: 24,
    p: 4,
};

const RequestApprovedPopup = ({ approvedPopupOpen, handleCloseApproved, warningMsg, requestItem }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const data = JSON.stringify({
            groupRequestAccepted: "accepted"
        });

        const config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/group-call/update/${requestItem?._id}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data,
        };

        try {
            const response = await axios.request(config);
            console.log('API Response:', response.data);

            // ─────────────────────────────────────────────────────────
            // Create staff activity log for group request approval
            // ─────────────────────────────────────────────────────────
            try {
                const staffData = loadDecrypted("HeartConnect-StaffData");
                const staffId = staffData?._id || staffData?.id || "";
                const staffName = staffData?.fullName || staffData?.name || "Unknown";

                if (staffId) {
                    await axios.post(
                        `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
                        {
                            staff: staffId,
                            action: "APPROVE_GROUP_REQUEST",
                            description: `Staff ${staffName} approved group request for group "${requestItem?.groupName}" (ID: ${requestItem?._id}) created by user ${requestItem?.createdBy?.nickName} (${requestItem?.createdBy?._id})`,
                        },
                        { headers: { "Content-Type": "application/json" } }
                    );
                }
            } catch (logErr) {
                console.error("Failed to create staff activity log:", logErr);
            }
            // ─────────────────────────────────────────────────────────

            setIsLoading(false);
            handleCloseApproved(); // Close the modal on success
        } catch (error) {
            console.error('API Error:', error);
            setIsLoading(false);
        }
    };

    return (
        <Modal
            open={approvedPopupOpen}
            onClose={handleCloseApproved}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="w-full">
                    <div className="flex items-center mb-4">
                        <img
                            src={requestItem?.createdBy?.selected_Avatar}
                            alt="Avatar"
                            className="w-14 h-14 rounded-full mr-2"
                        />
                        <h2 className="text-xl font-semibold tracking-wide">
                            {requestItem?.createdBy?.nickName}
                        </h2>
                    </div>
                    <div className='flex flex-col justify-center'>
                        <div className="flex items-center mb-4">
                            <label className="text-xl font-semibold tracking-wide">
                                Group Name :
                            </label>
                            <h2 className="text-xl font-semibold tracking-wide">
                                {requestItem?.groupName}
                            </h2>
                        </div>
                        <div className="flex items-center mb-4">
                            <label className="text-xl font-semibold tracking-wide">
                                Language :
                            </label>
                            <h2 className="text-xl font-semibold tracking-wide">
                                {requestItem?.groupLanguage}
                            </h2>
                        </div>

                        <div className="flex justify-end space-x-4 tracking-wide">
                            <button
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                                onClick={handleCloseApproved}
                            >
                                Cancel
                            </button>
                            {isLoading ? (
                                <button
                                    className="w-full flex justify-center items-center bg-[#c51369] p-3 rounded-md text-white font-medium"
                                    disabled
                                >
                                    <BtnLoader />
                                </button>
                            ) : (
                                <button
                                    onClick={handleSubmit}
                                    className="bg-[#c51369] text-white p-3 rounded-md hover:bg-[#a10f5b] transition duration-200 font-medium"
                                >
                                    {warningMsg}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default RequestApprovedPopup;






// import React, { useState } from 'react';
// import Box from '@mui/material/Box';
// import Modal from '@mui/material/Modal';
// import BtnLoader from 'Components/Common/Loader/BtnLoader';
// import axios from 'axios';

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '90%',
//     maxWidth: 500,
//     bgcolor: 'background.paper',
//     border: 'none',
//     borderRadius: 8,
//     boxShadow: 24,
//     p: 4,
// };

// const RequestApprovedPopup = ({ approvedPopupOpen, handleCloseApproved, warningMsg, requestItem }) => {
//     const [isLoading, setIsLoading] = useState(false);


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         const data = JSON.stringify({
//             groupRequestAccepted: "accepted"
//         });

//         const config = {
//             method: 'put',
//             maxBodyLength: Infinity,
//             url: `${process.env.REACT_APP_API_URL}/group-call/update/${requestItem?._id}`,
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             data,
//         };

//         try {
//             const response = await axios.request(config);
//             console.log('API Response:', response.data);
//             // Optionally show a success message or perform further actions
//             setIsLoading(false);
//             handleCloseApproved(); // Close the modal on success
//         } catch (error) {
//             console.error('API Error:', error);
//             // Optionally show an error message
//             setIsLoading(false);
//         }
//     };


//     return (
//         <Modal
//             open={approvedPopupOpen}
//             onClose={handleCloseApproved}
//             aria-labelledby="modal-modal-title"
//             aria-describedby="modal-modal-description"
//         >
//             <Box sx={style}>
//                 <div className="w-full">
//                     <div className="flex items-center mb-4">
//                         <img
//                             src={requestItem?.createdBy?.selected_Avatar}
//                             alt="Avatar"
//                             className="w-14 h-14 rounded-full mr-2"
//                         />
//                         <h2 className="text-xl font-semibold tracking-wide">
//                             {requestItem?.createdBy?.nickName}
//                         </h2>
//                     </div>
//                     <div className='flex flex-col justify-center'>
//                         <div className="flex items-center mb-4">
//                             <label className="text-xl font-semibold tracking-wide">
//                                 Group Name :
//                             </label>
//                             <h2 className="text-xl font-semibold tracking-wide">
//                                 {requestItem?.groupName}
//                             </h2>
//                         </div>
//                         <div className="flex items-center mb-4">
//                             <label className="text-xl font-semibold tracking-wide">
//                                 Language :
//                             </label>
//                             <h2 className="text-xl font-semibold tracking-wide">
//                                 {requestItem?.groupLanguage}
//                             </h2>
//                         </div>

//                         <div className="flex justify-end space-x-4 tracking-wide">
//                             <button
//                                 className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
//                                 onClick={handleCloseApproved}
//                             >
//                                 Cancel
//                             </button>
//                             {isLoading ? (
//                                 <button
//                                     className="w-full flex justify-center items-center bg-[#c51369] p-3 rounded-md text-white font-medium"
//                                     disabled
//                                 >
//                                     <BtnLoader />
//                                 </button>
//                             ) : (
//                                 <button
//                                     onClick={handleSubmit}
//                                     className="bg-[#c51369] text-white p-3 rounded-md hover:bg-[#a10f5b] transition duration-200 font-medium"
//                                 >
//                                     {warningMsg}
//                                 </button>
//                             )}
//                         </div>
//                     </div>


//                 </div>
//             </Box>
//         </Modal>
//     );
// };

// export default RequestApprovedPopup;
